import { Button } from 'bitmovin-player-ui';
export function createAdButton(npoplayer) {
    npoplayer.uiComponents.adbutton = undefined;
    const adButton = new Button({
        cssClass: 'ui-textbutton ui-sterbutton bmpui-ui-button',
        text: 'Ga naar website van adverteerder',
        hidden: true
    });
    npoplayer.uiComponents.adbutton = adButton;
    return adButton;
}
